import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
  className?: string;
}

export default function DramaCard({ drama, className = '' }: DramaCardProps) {
  return (
    <Link to={`/detail/${drama.id}`} className={`group block cursor-pointer ${className}`}>
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-800">
        <img
          src={drama.poster}
          alt={`${drama.title} 海报`}
          title={`${drama.title} - 成人短剧精选`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent" />
        <span className="absolute top-2.5 left-2.5 inline-flex items-center gap-1 rounded-md bg-background-950/70 backdrop-blur px-2 py-0.5 text-xs font-semibold text-accent-300">
          <i className="ri-star-fill text-[10px]" />
          {drama.rating.toFixed(1)}
        </span>
        <span className="absolute top-2.5 right-2.5 rounded-md bg-primary-600/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {drama.year}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="text-sm font-semibold text-foreground-50 truncate">{drama.title}</h3>
          <p className="mt-1 text-xs text-foreground-400 truncate">
            {drama.region} · {drama.episodes}
          </p>
        </div>
      </div>
    </Link>
  );
}